module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phand0-70dd4d1e0e26b86d4960f6b0822c09b5.jpg";